export const RESET = 'EXSBREASON_UPDATE_RESET'
export const SET_ERROR = 'EXSBREASON_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBREASON_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBREASON_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBREASON_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBREASON_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBREASON_UPDATE_UPDATE_RETRIEVED'
